
"use strict";

/**
 * This file is automatically generated by the binary command running
 * after the package installation based on your configuration file.
 */

var config = {
  publicPath: "/static/design",
  iconsPublicPath: "/static/design/icons.svg"
};

exports.__esModule = true;
exports.default = config;
